export function parseFormValue<T>(input: T): T | null | undefined {
  if (typeof input === 'string' && input === '') {
    return null;
  }

  if (input === undefined) {
    return undefined;
  }

  return input;
}
